var map = {
	"./blood_elf_female.gif": 3331,
	"./blood_elf_male.gif": 2572,
	"./draenei_female.gif": 997,
	"./draenei_male.gif": 1314,
	"./dwarf_female.gif": 5833,
	"./dwarf_male.gif": 470,
	"./gnome_female.gif": 9929,
	"./gnome_male.gif": 9830,
	"./human_female.gif": 9488,
	"./human_male.gif": 9291,
	"./night_elf_female.gif": 6129,
	"./night_elf_male.gif": 9758,
	"./orc_female.gif": 6079,
	"./orc_male.gif": 6840,
	"./tauren_female.gif": 6722,
	"./tauren_male.gif": 7017,
	"./troll_female.gif": 3126,
	"./troll_male.gif": 1661,
	"./undead_female.gif": 4712,
	"./undead_male.gif": 4995
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69;